'use client'

import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

interface Props {
    onload: (params: URLSearchParams) => void
}

export function SearchParamsOnLoad({ onload }: Props) {
    const search = useSearchParams()

    useEffect(() => {
        onload(search)
    }, [search, onload])

    return null
}
